import Cookie from 'cookie-universal'

export const getGDPRCheckboxValue = () => {
  const cookies = Cookie()
  return cookies.get('gdpr_checked') || null
}
